import React from 'react'

const Criticalthinking = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. The words in the crossword puzzle are from the text. Find them from the text to solve the puzzle based on the meaning clues given below.</p>
        <p>1. unquestionable, impossible to doubt</p>
        <strong>indubitable</strong>
        <p>2. never done or known before</p>
        <strong>unprecedented</strong>
        <p>3. emergence or origination</p>
        <strong>emanation</strong>
        <p>4. obviously or clearly</p>
        <strong>evidently</strong>
        <p>5. impossible to achieve or overcome</p>
        <strong>insuperable</strong>
        <p>6. moved with a violent, irregular action</p>
        <strong>agitated</strong>
        <p>7. appropriate or suitable</p>
        <strong>apt</strong>
        <p>8. force back</p>
        <strong>repel</strong>
        <p>9. conservative</p>
        <strong>orthodox</strong>
        <p>10. up to now</p>
        <strong>hitherto</strong>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Find the words from the text that mean the following.</p>
        <p>a. misleading or illusionary</p>
        <strong>deceptive</strong>
        <p>b. in a natural state; not yet processed or refined</p>
        <strong>crude</strong>
        <p>c. a mystical horse like animal with a single straight horn projecting from its forehead </p>
        <strong>unicorn</strong>
        <p>d. never dying or decaying</p>
        <strong>immortal</strong>
        <p>e. come to an end; stop</p>
        <strong>cease</strong>
        <p>f. to activate or put into motion</p>
        <strong>actuate</strong>
      </div>
      <hr/>
      <div>
        <h3>Comprehension</h3>
        <p className='question'>Answer these questions.</p>
        <p className='question'>a. What's the difference between the body and the soul?</p>
        <p>= The body is the physical part of a person that we can see and touch. It lives in both time and space. The soul, on the other hand, is invisible and lives in time only. The body grows, changes, and dies, but the soul is believed to live on even after the body dies.</p>
        <p className='question'>b. What do you understand by the psychologists' saying that there is no such thing as mind?</p>
        <p>= Psychologists say that the mind is not a physical thing you can see or touch. Instead, they study how people think, feel, and behave by watching what they do and how they interact with others and the world. So, when they say there is no such thing as the mind, they mean it is not a thing by itself, but a way to understand what is happening inside us.</p>
        <p className='question'>c. How can a mental activity be reduced to a physical activity?</p>
        <p>= Mental activity can be seen as a physical activity because the mind is connected to the body, especially the brain. When we think or feel emotions, it is actually the brain working in different ways. So, mental activities like thoughts and feelings are linked to physical processes happening inside our body.</p>
        <p className='question'>d. How are mind and body related?</p>
        <p>= The mind and body are connected because they work together to control what happens inside a person. The body includes the brain and all physical parts, while the mind includes thoughts and feelings. They affect each other, and together they make us who we are.</p>
        <p className='question'>e. What is the relation between mind and memory? Does memory survive a person's death?</p>
        <p>= Memory is a part of the mind that helps us remember things. It lives in the brain. When a person dies, the brain also dies. So, memory does not stay after death.</p>
        <p className='question'>f. How is our power on the earth's surface entirely dependent upon the sun?</p>
        <p>= Our power on Earth depends on the sun because it gives us heat and light. The sun warms the oceans, controls the weather, and helps plants grow. Plants give us food and oxygen, so without the sun, life would not be possible.</p>
      </div>
      <hr/>
      <div>
        <h3>Critical Thinking</h3>
        <p className='question'>a. Do you believe that soul really exists? Write your arguments in support of your answer.</p>
        <p>= Yes, I believe that the soul really exists. Even though we can't see it, I think it is the part of us that feels, thinks, and makes us who we are. When we feel emotions like love, kindness, or sadness, it's not just the body doing that, it comes from deep inside. That deep part is what I believe is the soul.
</p><p>
Also, our body changes as we grow older, but we still feel like the same person inside. That feeling comes from the soul. Everyone is different not just because of how they look, but because of how they think and feel. That also shows we have souls that are unique.
</p><p>
Many people and religions in the world believe that the soul never dies, even when the body does. It is said to live on after death. Even though science can't prove it clearly, I believe the soul is real because it gives life meaning, feeling, and purpose.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. If you want to change your body, you first have to change your mind. Discuss.</p>
        <p>= Yes, I agree with the statement that if we want to change our body, we have to change our mind first. Our body only does what our mind tells it to do. So, if we think in a negative way, it becomes very hard to stay healthy or follow a fitness plan.
</p><p>
Sometimes, people say things to themselves like “I can't do this” or “I'll never get fit.” These kinds of thoughts stop them from trying. That's why it's important to think positively and believe in ourselves. If our mind is strong and motivated, then we can slowly start changing our body too.
</p><p>
For example, if someone wants to be fit, they have to stop thinking “I'm too lazy” or “I don't have time” and start thinking “I can do this,” even if it's hard at first. With time and practice, exercise becomes a habit. When we see good results like more energy, better sleep, or losing some weight, we feel even more motivated.
</p><p>
In the end, the first step to becoming healthier or stronger is not just going to the gym or eating better, it's changing how we think. A positive mind helps us take care of our body.</p>
      </div>
      <hr/>
      <div>
        <h3>Writing</h3>
        <p className='question'>Write critically on the given topics.</p>
        <p>= Many people believe in God, while others are not so sure. The question of whether God exists is one of the oldest and most important questions humans have asked. Some people believe in God because of their religion, personal experiences, or the way they see the world around them. Others may doubt God's existence because of things like suffering and evil in the world.
</p><p>
The Bible, one of the most famous religious books, talks about God a lot. It doesn't try to prove that God exists, it simply says He does. In the Bible, the question is not "Does God exist?" but "Who is God?" It talks about how we can know God through nature and the world He created. For example, the beauty of the sky, the complexity of animals, and the way life works make many people feel like there must be a Creator behind it all.
</p><p>
Some people, like philosophers and scientists, try to prove or disprove God's existence with logical arguments. Some say that the world is too perfectly designed to have come from nothing. Others say that the existence of pain and evil means God might not exist. But even with these questions, many still believe that God has a reason for everything, even if we don't understand it.
</p><p>
There are also people who believe in God without needing any proof. They say that faith is enough, and that feeling God's presence in their hearts is what really matters. On the other hand, atheists believe that there is no God, and they try to explain everything through science and facts.
</p><p>
In the end, the existence of God is a personal belief. Some believe strongly, some don't, and some are still searching. Whether through faith, science, nature, or personal experience, people have different ways of understanding the world and their place in it. And even if we don't all agree, the question of God's existence will always be one of the most interesting and meaningful questions in life.

</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>A. Rewrite the following sentences using 'used to'. You can make an affirmative/ negative statement or a question.</p>
        <p>a. I/live in a flat when I was a child.</p>
        <p>= I used to live in a flat when I was a child.</p>
        <br/>
        <p>b. She/love eating chocolate but now she hates it.</p>
        <p>= She used to love eating chocolate but now she hates it.</p>
        <br/>
        <p>c. He/go to fishing in the summer?</p>
        <p>=  Did he use to go fishing in the summer?</p>
        <br/>
        <p>d. My sister/play tennis when she was at school.</p>
        <p>= My sister used to play tennis when she was at school.</p>
        <br/>
        <p>e. He/play football every weekend?</p>
        <p>= Did he use to play football every weekend?</p>
        <br/>
        <p>f. My grandfather/speak five languages.</p>
        <p>= My grandfather used to speak five languages.</p>
        <br/>
        <p>g. I/not hate school from the beginning.</p>
        <p>= I didn't use to hate school from the beginning.</p>
        <br/>
        <p>h. You/live in Kathmandu?</p>
        <p>= Did you use to live in Kathmandu?</p>
        <br/>
        <p>i. He/play Dandibiyo when he was a small child.</p>
        <p>= He used to play Dandibiyo when he was a small child.</p>
        <br/>
        <p>j. She/wear a frock when she was small but nowadays she wears jeans.</p>
        <p>= She used to wear a frock when she was small but nowadays she wears jeans.</p>
      </div>
    </div>
  )
}

export default Criticalthinking
